<template>
  <div class="container" :class="{ logged: logged }">
    <div class="icon-container">
      <div class="floating front">
        <img v-if="imageUrl_" :src="imageUrl_" @error="handleError" />
      </div>
      <div class="floating back">
        <i class="fas fa-user" :class="{ logged: logged }"></i>
      </div>
    </div>
  </div>
</template>

<script>
import FontAwesome from "../../../public/js/lib/FontAwesomeKit"; // <--- importing FontAwesome icons
import ThemeManager from "../../modules/ThemeManager/ThemeManager";

export default {
  props: {
    imageUrl: {
      type: String,
      default: null,
    },
    logged: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      errorImageUrl: false,
      imageUrl_: ThemeManager.parseWebstarDefaultsImageUrl(this.imageUrl),
    };
  },
  methods: {
    handleError() {
      this.errorImageUrl = true;
      this.imageUrl_ = null;
    },
  },
  watch: {
    "$store.state.general.site_type": function() {
      this.imageUrl_ = ThemeManager.parseWebstarDefaultsImageUrl(this.imageUrl);
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";

$SIZE: 2.5em;

.container {
  width: $SIZE;
  height: $SIZE;
  border-radius: 100%;
  border: 1px solid var(--pallete_dark_text_color);
  background-color: var(--background_02);

  &.logged {
    border-color: var(--pallete_main_color);
  }
}

.icon-container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;

  .floating {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    &.front {
      z-index: 10;
    }

    &.back {
      z-index: 5;
    }
  }

  i {
    text-align: center;
    margin: auto;
    color: var(--pallete_dark_text_color);

    &.logged {
      color: var(--pallete_main_color);
    }
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
</style>
